// Async boundary for Module Federation share scope initialization.
// This dynamic import allows MF to negotiate shared dependencies
// before bootstrap.tsx runs any React/library code.
import('./bootstrap');
